
<div>
    <fc-content-header-summary class="fc-content-default" *ngFor="let c of content.components" [content]="c">
        <div [innerHtml]="c.content | marked: analyticsMode"></div>
    </fc-content-header-summary>
</div>